/**
 * Builds the grouped-field indexes a device is missing, one at a time.
 *
 * A record's reference and select fields are indexed on the expression the
 * views read (see `fieldIndexes` in insight-views.ts). A schema that changes
 * builds its own as it lands; this driver covers a device whose records were
 * already here when the indexes were introduced. Each index reads the whole
 * record once, so the driver yields to the screen between them and runs only
 * one pass at a time, exactly as the search backfill does.
 */
import { buildOneFieldIndex } from '@/lib/entry-repo';

const yieldToScreen = (): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), 0);
  });

let running = false;

/** A ceiling, so a schema that somehow never settles cannot loop forever. */
const MAX_BUILDS = 200;

export const runFieldIndexBackfill = async (): Promise<void> => {
  if (running) return;
  running = true;
  try {
    for (let built = 0; built < MAX_BUILDS; built += 1) {
      await yieldToScreen();
      if (!buildOneFieldIndex()) break;
    }
  } finally {
    running = false;
  }
};
